import React from 'react';
import InfoCard from './InfoCard';
import styles from '../TripTrackingV2.module.scss';

const LastKnownLocationCard = ({ trip }) => {
  const { lastKnownLocation, distance } = trip;
  if (!lastKnownLocation) return null;

  const covered = parseInt(lastKnownLocation.distance_covered || 0, 10);
  const total = parseInt(distance || 0, 10);
  const percentCovered = total ? Math.min(100, Math.round((covered / total) * 100)) : 0;

  return (
    <InfoCard title="Last known location">
      <div className={styles.locationRow}>
        <div className={styles.locationIcon}>
          <img src="/images/maps-and-flags.svg" width="15" height="21" />
        </div>
        <div>
          <div className={styles.locationName}>{lastKnownLocation.location}</div>
          <div className={styles.metaLine}>
            {lastKnownLocation.date.format('DD MMM, YYYY')} | {lastKnownLocation.time}
          </div>
          {lastKnownLocation.eta && (
            <div className={styles.metaLine}>ETA: {lastKnownLocation.eta.format('DD MMM, YYYY HH:mm')}</div>
          )}
          <div className={styles.metaLine}>{`Distance covered: ${covered}/${total} km`}</div>
          <div className={styles.progressTrack}>
            <div className={styles.progressFill} style={{ width: `${percentCovered}%` }} />
          </div>
        </div>
      </div>
    </InfoCard>
  );
};

export default LastKnownLocationCard;
